import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'

Vue.use(Vuex)

// https://webpack.js.org/guides/dependency-management/#requirecontext
const modulesFiles = require.context('./modules', true, /\.js$/)

// you do not need `import app from './modules/app'`
// it will auto require all vuex module from modules file
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  // set './app.js' => 'app'
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default
  return modules
}, {})

const store = new Vuex.Store({
  modules,
  getters,
  state: {
    nodeMap: new Map(),
    isEdit: null,
    selectedNode: {},
    selectFormItem: null,
    design: {},
    sort: '1',
    formValue: {},

  },
  mutations: {
    selectedNode (state, val) {
      state.selectedNode = val
    },
    loadForm (state, val) {
      state.design = val
    },
    setIsEdit (state, val) {
      state.isEdit = val
    },
    setSort (state, val) {
      state.sort = val
    },
    setFormValue (state, val) {
      state.formValue = val
    },
    updateFormItemValue (state, payload) {
      const { id, value } = payload;
      const item = state.design.formItems.find(e => e.id === id);
      if (item) {
        Vue.set(item, 'value', value); // 使用 Vue.set 确保响应式
      }
    },
    setFormValues (state, value) {
      state.design.formItems = value;
    },
  },
})

export default store
